let codeings=[
    "jsgl",
    "jsqxgl",
    "cwgl",
    "tjcp",
    "sccj",
    "cpxx",
    "chck",
    "wlxx",
    "tgdw",
    "scdd",
    "wlgl",
    "kcgl",
    "shgl",
    "thgl",
    "cpdj",
    "rkmx",
    "rkhzb",
    "xsmxb",
    "xshzb",
    "kcbb",
    "kcpdb",
    "jxcmxb",
    "jxchzb",
    "khgl",
    "hl",
    "ktrz",
    "jhrz",
    "czrz",
]
export default codeings
// All